import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { UUID } from "angular2-uuid";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { wfsService } from "src/app/shared/services/wfs.service";
import { CognitoService } from "src/app/shared/services/cognito.service";

@Component({
  selector: "app-classes",
  templateUrl: "./classes.component.html",
  styleUrls: ["./classes.component.sass"],
})
export class ClassesComponent implements OnInit {
  className: string;
  classType: string;
  validation: string;
  showadd: boolean = false;
  showsave: boolean = true;
  classForm: FormGroup;
  classArray: any[] = [];
  showValidationDiv: boolean;
  classTypesList = [
    "string",
    "number",
    "decimal",
    "list",
    "email",
    "phone",
    "aadhar",
    "image",
    "video",
    "custom",
    "gps",
  ];
  value: any;
  parametersArray = [];
  variableName: string = "";
  editedArray: any = [];
  editRow: any[] = [];
  peditRow: any[] = [];
  // detailsObj = { name: "", dataType: "", metaData: {} };
  detailsObj: any = {};
  prviousdetailsObj = { variableName: "", dataType: "", metaData: {} };
  enable: boolean = false;
  loading: boolean;
  classesList = [];
  dataType: any;
  metaData: string;
  metaDataInfo: any;
  dataTypesList = ["String", "Decimal", "Object", "List", "Number", "Int"];
  stringMetaData: {
    max: number;
    min: number;
    alphanumeric: boolean;
    regex: string;
  };
  phoneNumberMetaData: { type: string };
  objectMetaData: {};
  numberMetaData: any;
  decimalMetaData: {};
  selectedRecord: "";
  integerMetaData: {};
  selectedUuid: any;
  version: any;
  type: string = "save";
  displayJson: boolean;
  showtext: boolean;
  btnLoading: boolean;
  invalidMetaData: boolean = false;
  invalidMetaData2: boolean = false;
  btnDone: boolean = false;
  showMetaData: boolean = true;
  listsArray: any[] = [];
  classId: any;
  selectedListId: any;
  selectedClassId: any;
  selectedListName: any;
  selectedClassName: any;
  indexArray: any[] = [];
  publishedClassesList: any;
  versionsList: any[] = [];
  showViewBtn: any[] = [];
  classData = [];
  selectedRec: any;
  showVersionDropdown: any[] = [];
  class: any = {};
  saveObj: {
    name: string;
    version: number;
    members: any[];
    uuid: string;
    classId: string;
    group: string;
  };
  updateObj: any;
  readOnly: boolean = false;
  showClassReadOnly: boolean;
  enableView: boolean = false;
  showSelectClass: boolean = false;
  showSelectList: boolean = false;
  isUpdateClicked: boolean = false;
  groupName: any;
  selectedList: any;

  constructor(
    private wfsService: wfsService,
    private cognitoService: CognitoService
  ) { }
  async ngOnInit() {
    await this.cognitoService.getCurrentUserToken().then((res: any) => {
      this.groupName = res.attributes.family_name;
    });
    this.getAllDraftClasses();
    this.getAllPublishedClasses();
    this.getAllLists();
  }
  getAllLists() {
    this.loading = true;
    this.listsArray = [];
    let obj = {
      // group: this.groupName,
    };
    this.wfsService.getAllLists(obj).then((data: any) => {
      if (data.length > 0) {
        this.listsArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }
  checkDataType(e) {
    if (e == "List") {
      this.showSelectClass = false;
      this.showMetaData = false;
      this.showSelectList = true;
      this.detailsObj.metaData = "";
    } else if (e == "Object") {
      this.showSelectClass = true;
      this.showMetaData = false;
      this.showSelectList = false;
      this.detailsObj.metaData = "";
    } else {
      this.showSelectList = false;
      this.showSelectClass = false;
      this.showMetaData = true;
      this.metaData = "";
      this.detailsObj.metaData = "";
    }
  }
  OnChangeListEdit(e) {
    this.selectedListName = e;
    this.selectedListId = this.listsArray.filter(
      (item) => item.name == e
    )[0].uuid;
    this.detailsObj.metaData = this.selectedListName;
    this.selectedList = this.listsArray.filter((item) => item.name == e)[0];
    console.log(" this.selectedList", this.selectedList);
    this.detailsObj["listId"] =
      this.detailsObj.dataType == "List" ? this.selectedListId : "";
  }
  onChangeClassEdit(e) {
    this.selectedClassName = e;
    this.selectedClassId = this.classesList.filter(
      (item) => item.name == e
    )[0].uuid;
    this.detailsObj.metaData = this.selectedClassName;
    this.detailsObj["classId"] =
      this.detailsObj.dataType == "Object" ? this.selectedClassId : "";
  }
  changeList(e) {
    this.selectedListId = e;
    this.selectedListName = this.listsArray.filter(
      (item) => item.uuid == e
    )[0].name;
    this.detailsObj.metaData = this.selectedListName;
    this.selectedList = this.listsArray.filter((item) => item.uuid == e)[0];
    console.log(" this.selectedList", this.selectedList)
    this.detailsObj["listId"] =
      this.detailsObj.dataType == "List" ? this.selectedListId : "";
  }
  changeClass(e) {
    this.selectedClassId = e;
    this.selectedClassName = this.classesList.filter(
      (item) => item.uuid == e
    )[0].name;
    this.detailsObj.metaData = this.selectedClassName;
    this.detailsObj["classId"] =
      this.detailsObj.dataType == "Object" ? this.selectedClassId : "";
  }
  addClass() {
    this.type = "save";
    this.showClassReadOnly = true;
    this.className = "";
    this.validation = "";
    this.metaData = "";
    this.dataType = "";
    this.variableName = "";
    this.showsave = true;
    this.showadd = true;
    this.parametersArray = [];
    this.classArray = [];
    this.readOnly = false;
  }
  editClass(rec) {
    this.btnDone = true;
    this.type = "update";
    this.selectedUuid = rec.uuid;
    this.showClassReadOnly = false;
    this.showadd = true;
    this.showValidationDiv = false;
    this.editedArray = [];
    this.parametersArray = [];
    this.version = rec.version;
    this.classId = rec.classId;
    this.className = rec.name;
    for (let i = 0; i < rec.members.length; i++) {
      let detailsObj = {
        name: rec.members[i].name,
        dataType: rec.members[i].dataType,
        metaData: rec.members[i].metaData,
      };
      if (rec.members[i].listId) {
        detailsObj["listId"] = rec.members[i].listId;
        if (rec.members[i].dependentOn) {
          detailsObj['dependentOn'] = rec.members[i].dependentOn;
        }
      } else if (rec.members[i].classId) {
        detailsObj["classId"] = rec.members[i].classId;
      }
      this.parametersArray.push(detailsObj);
    }
    this.readOnly = false;
  }
  viewData(rec, index, view) {
    this.btnDone = true;
    this.type = "update";
    this.readOnly = view == "active" ? true : false;
    this.selectedUuid = rec.uuid;
    this.showadd = true;
    this.showValidationDiv = false;
    this.editedArray = [];
    this.parametersArray = [];
    this.version = this.class.version;
    this.classId = this.class.classId;
    this.className = this.class.name;
    for (let i = 0; i < this.class.members.length; i++) {
      let detailsObj = {
        name: this.class.members[i].name,
        dataType: this.class.members[i].dataType,
        metaData: this.class.members[i].metaData,
      };
      if (this.class.members[i].listId) {
        detailsObj["listId"] = this.class.members[i].listId;
      } else if (this.class.members[i].classId) {
        detailsObj["classId"] = this.class.members[i].classId;
      }
      this.parametersArray.push(detailsObj);
    }
    this.closeVersionDropdown(null);
  }
  showVariables() {
    this.showValidationDiv = true;
    this.variableName = "";
    this.dataType = "";
    this.metaData = "";
  }

  testJSON(text) {
    if (text == "" || text == undefined) {
      return true;
    }
    if (typeof text !== "string") {
      return false;
    }
    try {
      JSON.parse(text);
      this.invalidMetaData = true;
      return true;
    } catch (error) {
      this.invalidMetaData = false;
      return false;
    }
  }
  testJSON2(text) {
    if (text == "" || text == undefined) {
      return true;
    }
    if (typeof text !== "string") {
      return false;
    }
    try {
      JSON.parse(text);
      this.invalidMetaData2 = true;
      return true;
    } catch (error) {
      this.invalidMetaData2 = false;
      return false;
    }
  }
  saveData() {
    let eobj = {
      name: this.variableName,
      dataType: this.dataType,
      // metaData : this.dataType=='List' ? this.selectedListName : this.metaData,
      metaData:
        this.dataType == "List"
          ? this.selectedListName
          : this.dataType == "Object"
            ? this.selectedClassName
            : this.metaData,
      listId: this.dataType == "List" ? this.selectedListId : "",
      // classId : (this.dataType=='Object') ? this.selectedClassId : ''
    };
    if (this.dataType == "List") {
      eobj["listId"] = this.selectedListId;
      if (this.selectedList.dependentOn) {
        console.log('dependentOn');
        eobj['dependentOn'] = this.selectedList.dependentOn;
        console.log('eobj', eobj);
      }
    } else if (this.dataType == "Object") {
      eobj["classId"] = this.selectedClassId;
    }
    this.parametersArray.push(eobj);
    this.showValidationDiv = false;
    this.variableName = "";
    this.dataType = "";
    this.metaData = "";
    this.btnDone = true;
  }
  deleteRow(index) {
    Swal.fire({
      title: "Are you sure you want to Delete ?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then((value: any) => {
      if (value.value) {
        this.parametersArray.splice(index, 1);
      }
    });
  }
  cancelAdd() {
    this.showsave = false;
    this.showadd = false;
    this.showValidationDiv = false;
    this.metaData = "";
    this.dataType = "";
    this.variableName = "";
    this.getAllPublishedClasses();
    this.getAllDraftClasses();
  }
  cancelSave() {
    this.showValidationDiv = false;
    this.metaData = "";
    this.dataType = "";
    this.variableName = "";
  }
  cancelupdate() {
    this.showValidationDiv = false;
    this.className = "";
    this.editedArray = [];
    this.parametersArray = [];
    this.showadd = false;
    this.getAllPublishedClasses();
    this.getAllDraftClasses();
  }
  editRowData(index) {
    console.log(this.parametersArray, this.listsArray)
    this.indexArray.push(index);
    this.btnDone = false;
    // this.type = 'update';
    this.detailsObj = { name: "", dataType: "", metaData: "" };
    this.detailsObj.name = this.parametersArray[index].name;
    this.detailsObj.dataType = this.parametersArray[index].dataType;
    this.detailsObj.metaData = this.parametersArray[index].metaData;
    if (this.detailsObj.dataType == 'List') {
      this.detailsObj.listId = this.parametersArray[index].listId;
      this.selectedList = this.listsArray.filter((item) => item.uuid == this.detailsObj.listId)[0];
      console.log("this.selectedList", this.selectedList);
      if (this.selectedList.dependentOn) {
        this.detailsObj.dependentOn = this.selectedList.dependentOn;
      }
    }
    console.log('@@Details obj in edit:', this.detailsObj, this.parametersArray);
    this.editRow[index] = true;
    this.enable = true;
    this.invalidMetaData2 = true;
  }

  updateRow(index) {
    this.editRow[index] = false;
    if (this.detailsObj.dataType == 'List') {
      console.log("this.selectedList", this.selectedList);
      if (this.selectedList.dependentOn) {
        console.log('dependentOn');
        this.detailsObj['dependentOn'] = this.selectedList.dependentOn;
        console.log('eobj', this.detailsObj);
      }
    }
    this.parametersArray[index] = this.detailsObj;
    console.log("parametersArray", this.parametersArray)
    this.detailsObj = { name: "", dataType: "", metaData: {} };
    this.enable = false;
    this.btnDone = true;
  }

  cancelRowEdit(index) {
    this.indexArray = this.indexArray.filter((item) => item != index);
    this.editRow[index] = false;
    this.detailsObj = { name: "", dataType: "", metaData: {} };
  }

  addmoreResource() {
    this.showsave = true;
  }
  saveClass() {
    this.loading = true;
    this.btnLoading = true;
    this.saveObj = {
      name: this.className,
      version: 1,
      members: this.parametersArray,
      uuid: UUID.UUID(),
      classId: UUID.UUID(),
      group: this.groupName,
    };
    console.log("@@Save class object:", this.saveObj);
    this.wfsService.saveClasses(this.saveObj).then((data: any) => {
      this.btnLoading = false;
      if (data) {
        this.publishClass(this.saveObj);
        this.loading = false;
        Swal({ title: "Class saved successfully!" });
        this.showadd = false;
        this.getAllPublishedClasses();
        this.getAllDraftClasses();
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          "Error",
          "Data not Submitted (please contact admin)",
          "error"
        );
        this.showadd = false;
      }
    });
  }
  closeClass() {
    this.loading = false;
    this.showadd = false;
    this.getAllPublishedClasses();
    this.getAllDraftClasses();
  }
  publishClass(rec) {
    rec["publishId"] = UUID.UUID();
    this.wfsService.saveClassPublish(rec).then((data: any) => {
      if (data) {
        console.log("@@Class published");
      }
    });
  }
  updateClass() {
    this.isUpdateClicked = true;
    this.indexArray.forEach((item) => (this.editRow[item] = false));
    this.loading = true;
    this.btnLoading = true;
    this.updateObj = {
      name: this.className,
      members: this.parametersArray,
      version: ++this.version,
      classId: this.classId,
    };
    this.updateObj["uuid"] = this.selectedUuid;
    delete this.updateObj._id;
    this.wfsService
      .updateClassDraft(this.updateObj, this.selectedUuid)
      .then((data: any) => {
        this.btnLoading = false;
        if (data) {
          this.publishClass(this.updateObj);
          this.loading = false;
          Swal({ title: "Updated successfully" });
          this.showadd = false;
          this.btnDone = true;
          this.parametersArray = [];
          this.isUpdateClicked = false;
          this.getAllDraftClasses();
          this.getAllPublishedClasses();
        } else {
          this.loading = false;
          this.btnLoading = false;
          this.isUpdateClicked = false;
          Swal.fire(
            "Error",
            "Data not Submitted (please contact admin)",
            "error"
          );
          this.btnDone = true;
          this.showadd = false;
        }
      });
  }
  getAllDraftClasses() {
    this.loading = true;
    this.classesList = [];
    let obj = {
      // group: this.groupName,
    };
    this.wfsService.getAllDraftClasses(obj).then((data: any) => {
      if (data.length > 0) {
        this.classesList = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }
  getAllPublishedClasses() {
    this.loading = true;
    this.publishedClassesList = [];
    let obj = {
      // group: this.groupName,
    };
    this.wfsService.getAllPublishedClasses(obj).then((data: any) => {
      if (data.length > 0) {
        this.publishedClassesList = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }
  showClassVersions(index) {
    this.selectedRec = this.classesList[index];
    this.closeVersionDropdown(index);
    this.getClassVersions(this.selectedRec.classId, index);
  }
  cancelVersionView(index) {
    this.closeVersionDropdown(null);
  }
  getClassVersions(classId, i) {
    this.versionsList = [];
    this.classData = [];
    let obj = {
      classId: classId,
    };
    this.wfsService.getAllPublishedClasses(obj).then((data: any) => {
      this.classData = data;
      this.versionsList = data.map((item) => ({
        uuid: item.publishId,
        version: item.version,
      }));
      this.showVersionDropdown[i] = true;
      this.showViewBtn[i] = true;
    });
  }
  closeVersionDropdown(versionIndex) {
    this.showVersionDropdown.forEach((item, index) => {
      if (versionIndex && versionIndex == index) {
        this.showVersionDropdown[index] = true;
        this.showViewBtn[index] = true;
      } else {
        this.showVersionDropdown[index] = false;
        this.showViewBtn[index] = false;
      }
    });
  }
  getSelectedVersion(value) {
    this.class = this.classData.find((item) => item.publishId == value);
    this.enableView = true;
  }
}
